export const Heading = "1.25rem";
export const Small = "0.9rem";
export const ActionText = "0.875ren";
export const MainColor = "#19073b";
export const BgColor = "#f6f7fa";
